module.exports = __webpack_public_path__ + "static/img/200002.ebb0ae67.png";